export enum EventName {
    KNOWLEDGE_BASED_ACTION_BANNER_CLICKED = "knowledge_base_action_banner_clicked",
    BOOKING_ACCEPTED = "booking_accepted",
    EDIT_LISTING = "edit_listing",
    EDIT_OUTFITTER = "edit_outfitter",
    CREATE_BOOKING = "create_booking",
    CREATE_ADDITIONAL_BOOKING_PAYMENT = "create_additional_booking_payment",
    DECLINED_BOOKING = "declined_booking",
    OFFLINE_PAYMENT = "offline_payment",
    CREATE_QUICK_PAY = "create_quick_pay",
    CREATE_COUPON = "create_coupon",
    ADDED_TEAM_MEMBER = "added_team_member",
    ADDITIONAL_PAYMENT_REQUEST = "additional_payment_request",
    AVAILABILITY = "availability",
    EXPORT_PAYMENTS_CSV = "export_payments_csv",
    EXPORT_REMAINING_PAYMENTS_CSV = "export_remaining_payments_csv",
    CREATE_BOOKING_INVITE = "create_booking_invite",
    CREATE_RESOURCE = "create_resource",
    EXPORT_CONTACT_LIST_CSV = "export_client_list_csv",
    AI_FEATURE_CLICKED = "ai_feature_clicked",
    ACCEPT_AI_SUGGESTION = "accept_ai_suggestion",
    CANCEL_AI_SUGGESTION = "cancel_ai_suggestion",
    CREATE_BOOKING_CLICKED_IN_CALENDAR = "create_booking_clicked_in_calendar",
    SELF_ONBOARDING_STEP_STARTED = "self_onboarding_step_started",
    SELF_ONBOARDING_STEP_COMPLETED = "self_onboarding_step_completed",
    SELF_ONBOARDING_COMPLETED = "self_onboarding_completed",
    EVENT_ORGANIZER_SELF_ONBOARDING_STEP_STARTED = "event_organizer_self_onboarding_step_started",
    EVENT_ORGANIZER_SELF_ONBOARDING_STEP_COMPLETED = "event_organizer_self_onboarding_step_completed",
    EVENT_ORGANIZER_SELF_ONBOARDING_COMPLETED = "event_organizer_self_onboarding_completed",
    APP_PROMPT_CTA_CLICKED = "app_prompt_cta_clicked",
}
